export const { ClientId, Authority } = window.AlphormConfiguration
